import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import {
  emailAddressValid,
  handleDetailResponse,
  mobileNumberValid,
  pancardValidation,
  seo,
  validateAadhaar,
  nameValid,
  isEmpty,
  filterAlphabetsOnlyName,
  visitorNameInputHasInvalidChars,
} from "utils/utils";
import { errorToast } from "utils/httpClient";
import { useDispatch, useSelector } from "react-redux";
import {
  bulkVisitDetail,
  bulkVisitForm,
  removeVisitorMobileCheck,
  visitorMobileCheck,
} from "../../reduxStore/action/visitorActions";
import { universalRemoveAction } from "../../reduxStore/action/authActions";
import moment from "moment";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import { VISITOR_MOBILE_CHECK } from "../../reduxStore/types";

const CreateVisitor = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [viewData, setViewData] = useState({});
  const [formVaild, setFormVaild] = useState(null);
  const [visitResponse, setVisitResponse] = useState({});
  const [visitModule, setVisitModule] = useState(false);
  const params = useParams();
  const { _id = "" } = params || {};
  const dispatch = useDispatch();
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const bulkVisitDetailSelector = useSelector((state) => state.visitor) || [];

  const visitorMobileCheckNumber = useSelector((state) => state.visitorMobileCheck) || [];

  const bulkVisitDataSelector =
    useSelector((state) => state.bulkVisitForm) || [];

  useEffect(() => {
    if (bulkVisitDataSelector.detail) {
      dispatch(bulkVisitForm(bulkVisitDataSelector.response.data));
    }
  }, [bulkVisitDataSelector]);

  useEffect(() => {
    if (bulkVisitDetailSelector.detail) {
      const { response } = bulkVisitDetailSelector;
      if (response?.status === 200) {
        setViewData(handleDetailResponse(response.data));
        const result = handleDetailResponse(response?.data);
        setForm({
          ...form,
          user_id: result?.login_id,
          property_id: result?.property_id,
          property_title: result?.property_title,
          document: result?.document,
        });
      }
    }
  }, [bulkVisitDetailSelector]);

  useEffect(() => {
    dispatch(bulkVisitDetail({ blk_lead_id: _id }));
  }, []);

  useEffect(() => {
    if (bulkVisitDataSelector.update) {
      setForm({ ...bulkVisitDataSelector.response });
    }
  }, [bulkVisitDataSelector]);
  useEffect(() => {
    if (visitorMobileCheckNumber?.response?.status) {
      dispatch(removeVisitorMobileCheck());
      if (visitorMobileCheckNumber?.response?.status === 200) {
        setForm({ ...form, visit_confirmation_status: 1 });
      } else {
        if (
          visitorMobileCheckNumber?.response?.status === 201 ||
          visitorMobileCheckNumber?.response?.status === 202
        ) {
          setVisitModule(true);
          setVisitResponse(visitorMobileCheckNumber?.response);
          dispatch(universalRemoveAction(VISITOR_MOBILE_CHECK))
        }
      }
    }
  }, [visitorMobileCheckNumber]);
  const handleLeftButton = () => {
    if (visitResponse?.status === 201) {
      setForm({ ...form, visit_confirmation_status: "", mobile: "" });
    } else {
      if (visitResponse?.status === 202) {
        const data = handleDetailResponse(visitResponse?.data)
        setForm({
          ...form,
          address: data?.address ? data?.address : '',
          adhar_no: data?.adhar_no ? data?.adhar_no : '',
          age: data?.age ? data?.age : '',
          agent_code: data?.agent_code ? data?.agent_code : '',
          area: data?.area ? data?.area : '',
          city: data?.city ? data?.city : '',
          coumpany_name: data?.coumpany_name ? data?.coumpany_name : '',
          current_stay: data?.current_stay ? data?.current_stay : '',
          desigantion: data?.desigantion ? data?.desigantion : '',
          email: data?.email ? data?.email : '',
          first_name: data?.first_name ? data?.first_name : '',
          funding_emi_type: data?.funding_emi_type ? data?.funding_emi_type : '',
          gender: data?.gender ? data?.gender : '',
          locality: data?.locality ? data?.locality : '',
          location: data?.location ? data?.location : '',
          marital_status: data?.marital_status ? data?.marital_status : '',
          mobile: data?.mobile ? data?.mobile : '',
          no_of_family_member: data?.no_of_family_member ? data?.no_of_family_member : '',
          occupation: data?.occupation ? data?.occupation : '',
          office_address: data?.office_address ? data?.office_address : '',
          pancard_no: data?.pancard_no ? data?.pancard_no : '',
          visit_type: data?.visit_type ? data?.visit_type : '',
          whatsapp_no: data?.whatsapp_no ? data?.whatsapp_no : '',
          birth_date: data?.birth_date ? moment(data?.birth_date).format("YYYY-MM-DD") : '',
          visit_confirmation_status: 2,
        });
      }
    }
  };
  const handleRightButton = () => {
    if (visitResponse?.status === 201) {
      setForm({ ...form, visit_confirmation_status: 1 });
    } else {
      if (visitResponse?.status === 202) {
        setForm({ ...form, visit_confirmation_status: 1 });
      }
    }
  };

  const handleInputField = (e) => {
    let fieldValue = e.target.value;
    if (e.target.name === "first_name") {
      if (visitorNameInputHasInvalidChars(fieldValue)) {
        errorToast(strings.nameValidErr);
      }
      fieldValue = filterAlphabetsOnlyName(fieldValue);
    } else if (e.target.name === "adhar_no") {
      fieldValue = fieldValue
        .replace(/\D/g, "")
        .split(/(?:([\d]{4}))/g)
        .filter((s) => s.length > 0)
        .join(" ");
    }
    const nextFormState = {
      ...form,
      [e.target.name]: fieldValue,
    };
    setForm(nextFormState);
  };
  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      location: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, location) => {
    const nextFormState = {
      ...form,
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleNext = () => {
    if (!handleValid()) {
      dispatch(bulkVisitForm(form));
      navigatpage("/createvisitornext/" + _id);
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.first_name) {
      formError = true;
      err["first_name"] = strings.customerName_Err;
    } else if (!nameValid(form.first_name)) {
      formError = true;
      err["first_name"] = strings.nameValidErr;
    }
    if (!form.mobile) {
      formError = true;
      err["mobile"] = strings.mobileErr;
    } else if (!mobileNumberValid(form.mobile)) {
      formError = true;
      err["mobile"] = strings.mobileValidErr;
    }
    if (form.whatsapp_no && !mobileNumberValid(form.whatsapp_no)) {
      formError = true;
      err["whatsapp_no"] = strings.mobileValidErr;
    }
    if (form.adhar_no && !validateAadhaar(form.adhar_no)) {
      formError = true;
      err["adhar_no"] = strings.validAadhar_Err;
    }
    if (form.pancard_no && !pancardValidation(form.pancard_no)) {
      formError = true;
      err["pancard_no"] = strings.validPancard_Err;
    }
    if (form.email && !emailAddressValid(form.email)) {
      formError = true;
      err["email"] = strings.emailValidationErr;
    }
    if (form.mobile && !form.visit_confirmation_status) {
      formError = true;
      err["visit_confirmation_status"] = strings.checkMobileNumber;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Create Visitor",
      metaDescription: "create visitor",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.createvisitor}
        url={"/newupload"}
        parentListing={strings.newuploadListing}
        titleactive={strings.CreateVisitor}
        isBackBtn={true}
      />
      {/*add_module_start */}
      {visitModule ? (
        <div
          className="modal show"
          tabIndex="-1"
          style={{
            display: "block",
          }}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {strings.conformation}
                </h5>
                <button
                  className="close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setVisitModule(false);
                    setForm({ ...form, visit_confirmation_status: "" });
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>
                    {visitResponse?.message === "" ||
                      visitResponse?.message === undefined ||
                      visitResponse?.message === null
                      ? strings.notavailable
                      : visitResponse?.message}
                  </h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-success mr-5"
                  type="button"
                  onClick={() => {
                    setVisitModule(false);
                    handleLeftButton();
                  }}
                  data-dismiss="modal"
                >
                  {visitResponse?.status === 201
                    ? strings.no
                    : visitResponse?.status === 202
                      ? strings.useOldData
                      : strings.notavailable}
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    setVisitModule(false);
                    handleRightButton();
                  }}
                  data-dismiss="modal"
                >
                  {visitResponse?.status === 201
                    ? strings.yes
                    : visitResponse?.status === 202
                      ? strings.createNew
                      : strings.notavailable}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* add_module_end */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.createvisitor}</h5>
              </div>
              <form className="form theme-form">
                <div className="row">
                  <div className="col-8">
                    <div className="card-body">
                      <div className="row p">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlLastName">
                              {strings.propertyname}
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlFirstName"
                              type="text"
                              name="property_title"
                              value={form.property_title}
                              readOnly
                              placeholder={strings.propertyname}
                              onChange={handleInputField}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row ">
                        <div className="col-md-12 ">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlFirstName">
                              {strings.visitorFullName}
                              <span className="required-field"></span>
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlFirstName"
                              type="text"
                              name="first_name"
                              value={form.first_name}
                              placeholder={strings.visitorFullName}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                            {formVaild?.first_name && (
                              <span style={{ color: "red" }}>
                                {formVaild?.first_name}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.mobileNo}
                              <span className="required-field"></span>
                            </label>
                            <input
                              className="form-control"
                              id="exampleInputMobileNo"
                              type="number"
                              maxLength={10}
                              name="mobile"
                              value={form.mobile}
                              placeholder={strings.mobileNo}
                              autoComplete="off"
                              onChange={(event) => {
                                if (event.target.value.length <= 10) {
                                  handleInputField(event);
                                }
                              }}
                              onBlur={() => {
                                if (form?.mobile?.length === 10) {
                                  dispatch(
                                    visitorMobileCheck({ mobile: form.mobile, user_id: form.user_id })
                                  );
                                }
                              }}
                            />
                            {formVaild?.mobile && (
                              <span style={{ color: "red" }}>
                                {formVaild?.mobile}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.emailAddress}
                            </label>
                            <input
                              className="form-control"
                              autoComplete="off"
                              id="exampleInputMobileNo"
                              type="email"
                              name="email"
                              value={form.email}
                              placeholder={strings.emailaddress}
                              onChange={handleInputField}
                            />
                            {formVaild?.email && (
                              <span style={{ color: "red" }}>
                                {formVaild?.email}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col-md-12 ">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlFirstName">
                              {strings.maritalStatus}
                            </label>
                            <select
                              className="form-control digits"
                              id="formcontrol-select1"
                              name="marital_status"
                              value={form.marital_status}
                              onChange={handleInputField}
                            >
                              <option defaultValue={null}>
                                {strings.selectMaritalStatus}
                              </option>
                              <option value={2}>{strings.married}</option>
                              <option value={1}>{strings.unmarried}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <AutocompletePlace
                              placeholder={strings.location}
                              value={form.location}
                              onChange={handleInputArea}
                              onSelect={onSelect}
                              label={strings.location}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.locality}
                            </label>
                            <input
                              className="form-control"
                              id="exampleInputMobileNo"
                              type="text"
                              name="locality"
                              value={form.locality}
                              placeholder={strings.locality}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.whatsappNo}
                            </label>
                            <input
                              className="form-control"
                              id="exampleInputMobileNo"
                              type="number"
                              maxLength={10}
                              name="whatsapp_no"
                              value={form.whatsapp_no}
                              placeholder={strings.whatsappNo}
                              onChange={(event) => {
                                if (event.target.value.length <= 10) {
                                  handleInputField(event);
                                }
                              }}
                              autoComplete="off"
                            />
                            {formVaild?.whatsapp_no && (
                              <span style={{ color: "red" }}>
                                {formVaild?.whatsapp_no}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row pb-3">
                        <div className="row pl-4 ">
                          <label
                            htmlFor="exampleInputMobileNo "
                            className="pr-5"
                          >
                            {strings.gender}
                          </label>
                          <div className="form-check pr-5">
                            <input
                              className="form-check-input "
                              type="radio"
                              id="flexRadioDefault1"
                              name="gender"
                              value={1}
                              checked={Number(form.gender) === 1 ? true : false}
                              onChange={handleInputField}
                            />
                            <label
                              className="form-check-label"
                              for="flexRadioDefault1"
                            >
                              {strings.male}
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="flexRadioDefault2"
                              name="gender"
                              value={2}
                              checked={Number(form.gender) === 2 ? true : false}
                              onChange={handleInputField}
                            />
                            <label
                              className="form-check-label"
                              for="flexRadioDefault2"
                            >
                              {strings.female}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.dateofBirth}
                            </label>
                            <input
                              className="form-control"
                              id="exampleInputMobileNo"
                              type="Date"
                              name="birth_date"
                              value={form.birth_date}
                              onChange={handleInputField}
                              min="1920-01-01"
                              max={moment()
                                .subtract(18, "years")
                                .format("yyyy-MM-DD")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlLastName">
                              {strings.aadharNo}
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlLastName"
                              type="text"
                              name="adhar_no"
                              maxLength={14}
                              value={form.adhar_no}
                              placeholder={strings.aadharNoExample}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                            {formVaild?.adhar_no && (
                              <span style={{ color: "red" }}>
                                {formVaild?.adhar_no}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1">
                              {strings.pancardNo}
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlInput1"
                              type="text"
                              name="pancard_no"
                              maxLength={10}
                              value={form.pancard_no}
                              placeholder={strings.panNumberExample}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                            {formVaild?.pancard_no && (
                              <span style={{ color: "red" }}>
                                {formVaild?.pancard_no}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlFirstName">
                              {strings.currentStay}
                            </label>
                            <select
                              className="form-control digits"
                              id="formcontrol-select1"
                              name="current_stay"
                              value={form.current_stay}
                              onChange={handleInputField}
                            >
                              <option defaultValue={null}>
                                {strings.currentStayselect}
                              </option>
                              <option value={"Rented"}>{strings.rented}</option>
                              <option value={"Owned"}>{strings.owned}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1">
                              {strings.familyMember}
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlInput1"
                              type="number"
                              name="no_of_family_member"
                              value={form.no_of_family_member}
                              placeholder={strings.familyMember}
                              onChange={handleInputField}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                if (e.target.value.length >= 2) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 d-flex justify-content-end">
                        <div className="card-footer">
                          <button
                            className="btn btn-color"
                            type="button"
                            onClick={() => handleNext()}
                          >
                            {strings.next}
                          </button>
                        </div>
                      </div>
                      {!isEmpty(formVaild) && (
                        <div className="col-md-12 float-right">
                          <span
                            style={{
                              color: "red",
                              float: "right",
                              // padding: "5px 15px 25px 5px",
                            }}
                          >
                            {strings.fieldRequired}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-4">
                    <img
                      src={form?.document}
                      className="img-fluid pt-5 h-75"
                      alt=""
                      type="file"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {visitModule && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};
export default CreateVisitor;
